
import '@/assets/scss/index.scss'
import { commonfunc } from '~/mixin/common'
export default {
  name: 'COLCTGR',
  components: { },
  mixins: [commonfunc],
  props: {
    lgCtgrNo: {
      type: String,
      // default: 'CTGR_00012' // required 'CTGR_00012'  "CTGR_00002" 주방 용품
      default: ''
    },
    titleYn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      cateSwiperOpt: {
        slidesPerView: 'auto',
        loop: false,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: true // 23.08.14 퍼블 추가
      },
      naviShow: true,
      ctgrList: [],
      ctgrdata: {
      },
      lcList: [],
      mcList: [],
      testData: { // 대카테고리 조회 리퀘스트 파라미터 'CTGR_00005'
        exhCtgrNo: ''
      }
    }
  },
  created () {
    // active prop 삽입하여 호출 시 active idx 교체
    if (this.active !== '') {
      this.activeIdx = this.active - 1
    }

    /*
    if (this.cateType === 'cateLink') {
      if (this.quick) {
        this.linkCate = this.quickLink
        this.cateSwiperOpt.slidesPerView = 10 // 23.10.16 disable 관련 추가
        // brand 타입 호출 시
      } else if (this.brand) {
        this.linkCate = this.brandLink
        this.cateSwiperOpt.slidesPerView = 11
      }
    }
    */
    // this.linkCate = this.quickLink
    // this.cateSwiperOpt.slidesPerView = 10
  },
  async  mounted () {
    if (this.cateType === 'cateMain' || this.cateType === 'cateLink') {
      this.swiperDisable()
    }
    await this.selCtgrList()
  },
  methods: {
    errorImage (e) {
      e.target.src = '/images/tempLy/ico_prob_cate02.png'
    },
    selCtgrList () {
      if (this.lgCtgrNo !== '') {
        this.testData.exhCtgrNo = this.lgCtgrNo
      }
      this.$AxiosBuilder
        .data(this.testData)
        .build()
        .post('/ds/ctgr')
        .then((res) => {
          const list = res.data.data

          list.forEach((item, idx) => {
            // 아이콘 이미지 주소는 추후 수정 예정입니다  '~/static/images/tempLy/ico_prob_cate02.png'
            // console.log('이미지 주소 ::: ', process.env.API_BASE_URL + item.pcIconAtchFileUrl)
            // console.log('이미지 주소2 ::: ', process.env.WEB_BASE_URL + item.pcIconAtchFileUrl)
            const newItem = Object.assign({}, this.ctgrData, { txt: item.exhCtgrNm, imgName: this.imgUrlMaker(item.pcIconAtchFileUrl), ctgNo: item.exhCtgrNo, link: item.pcLinkUrl })
            this.lcList.push(newItem)
            // console.log('테스트중' + this.lcList[idx].title + ':: ' + this.lcList[idx].icon + ':: ' + this.lcList[idx].ctgNo)

            const routeLgCtgrNo = this.$route.params.lgCtgrNo
            if (item.exhCtgrNo === routeLgCtgrNo) { // 카테고리 모아보기를 메인에 붙였을때 대카메뉴인 경우 중카테고리 보여주기
              const childList = list[idx].childCategories
              const allObj = { // 중카전체 추가 ..
                txt: '전체',
                imgName: '',
                url: '/ds/exhCtgr/C208/' + item.exhCtgrNo
              }
              this.mcList.push(allObj)
              console.log('childList' + childList)
              childList.forEach((childItem, i) => {
                const newChildItem = Object.assign({}, { txt: childItem.exhCtgrNm, imgName: this.imgUrlMaker(item.pcIconAtchFileUrl), ctgNo: childItem.exhCtgrNo, link: childItem.pcLinkUrl })

                this.mcList.push(newChildItem)
                // console.log('중카테스트중' + this.mcList[i].title + ':: ' + this.mcList[i].icon + ':: ' + this.mcList[i].ctgNo)
              })
            }
          })
          if (this.mcList.length === 0) { // 대카 화면이 아닐때
            this.ctgrList = this.lcList
          } else { // 대카화면에서 중카보여주기
            this.ctgrList = this.mcList
          }

          // 카테고리 갯수 설정 노출개수 이하 시 navigation 숨김, 클릭 안됨
          if (this.ctgrList.length <= this.cateSwiperOpt.slidesPerView) {
            this.naviShow = false
            this.cateSwiperOpt.allowTouchMove = false
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    // 23.10.16 disable 관련 추가
    // 전체 넓이가 스와이퍼 넓이보다 적을 때 스와이프 비활성화
    swiperDisable () {
      const swipeWrapWidth = this.$refs.cateSwiper.$el.clientWidth
      const swiperItem = this.$refs.cateSwiper.$el.querySelectorAll('.swiper-slide')
      let swiperTotalWidth = 0

      swiperItem.forEach((item) => {
        swiperTotalWidth += item.clientWidth
      })

      if (swiperTotalWidth < swipeWrapWidth && this.naviShow === true) {
        this.$refs.cateSwiper.swiper.allowTouchMove = false
        this.naviShow = false
      }
    },
    // 23.10.13 추가
    activeSet () { // 로드 시 active 설정
      if (this.cateType === 'cateMain') {
        this.$refs.cateSwiper.swiper.slideTo(this.activeIdx)
      }
    },
    test () {
      if (this.$refs.cateSwiper.swiper.clickedIndex !== undefined) {
        this.$refs.cateSwiper.swiper.slideTo(this.$refs.cateSwiper.swiper.clickedIndex)
        console.log(this.$refs.cateSwiper.swiper.clickedIndex, this.$refs.cateSwiper.activeIndex)
      }
    }
  }
}
